import Swiper from 'swiper';
import { Pagination, A11y, Keyboard } from 'swiper/modules';
import 'snippets/swiper-controls/swiper-control';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_collage.scss';
var MOBILE_BREAKPOINT = 768;
var SECTION_SELECTOR = '.collage';
var SECTION_CLASS = 'collage';
var CAROUSEL_SELECTOR = '.carousel--collage';
var CAROUSEL_CLASS = 'carousel--collage';
var PAGINATION_SELECTOR = '.swiper-pagination';
var MOBILE_SLIDES_PER_PAGE = 1;
var MOBILE_SLIDES_PER_VIEW = 1.25;
var instances = [];
function setupCollage(sectionEl, index) {
  var _sectionEl$querySelec;
  var carousel = sectionEl.querySelector(CAROUSEL_SELECTOR);
  if (!carousel) return;
  if (sectionEl.dataset.mobileLayout !== 'carousel') return;
  if (sectionEl.dataset.mobileSliderEnabled !== 'true') return;
  var slidesCount = carousel.querySelectorAll('.collage__slide').length;
  if (slidesCount <= MOBILE_SLIDES_PER_PAGE) return;
  var state = {
    sectionEl,
    carousel,
    swiper: null,
    slidesPerView: MOBILE_SLIDES_PER_VIEW,
    slidesPerGroup: MOBILE_SLIDES_PER_PAGE,
    paginationSelector: ".".concat(SECTION_CLASS, "-pagination-").concat(index)
  };
  carousel.classList.add("".concat(CAROUSEL_CLASS, "-").concat(index));
  (_sectionEl$querySelec = sectionEl.querySelector(PAGINATION_SELECTOR)) === null || _sectionEl$querySelec === void 0 || _sectionEl$querySelec.classList.add("".concat(SECTION_CLASS, "-pagination-").concat(index));
  instances.push(state);
  handleSwiperState(state);
}
function handleSwiperState(state) {
  if (window.innerWidth >= MOBILE_BREAKPOINT) {
    if (state.swiper) {
      state.swiper.destroy(true, true);
      state.swiper = null;
    }
    return;
  }
  if (state.swiper) return;
  state.swiper = new Swiper(state.carousel, {
    modules: [Pagination, A11y, Keyboard],
    slidesPerView: state.slidesPerView,
    slidesPerGroup: state.slidesPerGroup,
    spaceBetween: 8,
    slidesOffsetAfter: 16,
    watchOverflow: true,
    keyboard: true,
    observer: true,
    observeParents: true,
    a11y: {
      slideRole: null
    },
    pagination: {
      el: state.paginationSelector,
      clickable: true,
      renderBullet: function renderBullet(bulletIndex, className) {
        var isActive = this.activeIndex === bulletIndex ? 'aria-current="true"' : '';
        return "<span type=\"button\" tabindex=\"0\" class=\"".concat(className, "\" ").concat(isActive, "></span>");
      }
    },
    on: {
      init(swiperInstance) {
        removeLazyFromVisibleSlides(swiperInstance);
      },
      slideChange(swiperInstance) {
        var bullets = state.sectionEl.querySelectorAll("".concat(state.paginationSelector, " .swiper-pagination-bullet"));
        var activePageIndex = swiperInstance.snapIndex || 0;
        bullets.forEach((bullet, bulletIndex) => {
          if (bulletIndex === activePageIndex) {
            bullet.setAttribute('aria-current', 'true');
          } else {
            bullet.removeAttribute('aria-current');
          }
        });
        removeLazyFromVisibleSlides(swiperInstance);
      }
    }
  });
  var paginationBullets = state.sectionEl.querySelectorAll("".concat(state.paginationSelector, " .swiper-pagination-bullet"));
  paginationBullets.forEach((bullet, bulletIndex) => {
    bullet.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        state.swiper.slideTo(bulletIndex * state.slidesPerGroup);
      }
    });
  });
}
function removeLazyFromVisibleSlides(swiperInstance) {
  swiperInstance.slides.forEach(slide => {
    var rect = slide.getBoundingClientRect();
    var inView = rect.left < window.innerWidth && rect.right > 0;
    if (inView) {
      var img = slide.querySelector('.collage__image[loading="lazy"]');
      if (img) {
        img.removeAttribute('loading');
      }
    }
  });
}
function init() {
  document.querySelectorAll(SECTION_SELECTOR).forEach((el, index) => setupCollage(el, index));
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}